module.exports = __webpack_public_path__ + "img/1f529.e757620.svg";